import { FormSwitchField, FormSwitchFieldProps } from '@dfl/mui-react-common';
import { memo } from 'react';

const IphoneSwitchField = ({ bg, ...props }: FormSwitchFieldProps & { bg?: string }) => {
  return (
    <FormSwitchField
      {...props}
      sx={{
        marginLeft: 0,
        '.MuiSwitch-root': {
          width: 36,
          height: 18,
          padding: 0,
          '& .MuiSwitch-switchBase': {
            padding: '3px',
            top: '-1px',
            '&.Mui-checked': {
              transform: 'translateX(16px)',
              color: '#fff',
              '& + .MuiSwitch-track': {
                backgroundColor: bg || 'primary.main',
                opacity: 1,
              },
            },
            '&.Mui-disabled': {
              color: '#BABABA',
              '& + .MuiSwitch-track': {
                backgroundColor: '#D9D9DC',
                opacity: 1,
              },
            },
          },
          '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 14,
            height: 14,
            padding: 0,
          },
          '& .MuiSwitch-track': {
            borderRadius: 22 / 2,
            backgroundColor: '#D9D9DC',
            opacity: 1,
          },
          flexDirection: 'column',
        },
        '.MuiTypography-root': {
          marginLeft: 1
        }
      }}
    />
  );
};

export default memo(IphoneSwitchField);
